import * as Yup from 'yup'

export const reviewFormSchema = Yup.object({
    review: Yup.string().required('Required'),
    // name: Yup.string().max(30, 'Name Length Should be between 3 an 30').min(3, 'Name Length Should be between 3 an 30').required('Required'),
    // email: Yup.string().email('Email is Invalid').required('Required'),
    // rating: Yup.number().required('Required')
})